module.exports = "/assets/data/61c5ccaa03ce75f8922d1e8044f4c766-SY23.data.json";